'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var extendChild = function extendChild(child) {
  var shape = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme = arguments[2];
  var props = arguments[3];
  var childToClone = child;

  if (!child) {
    return null;
  }

  if (child.length) {
    childToClone = child[0];
  }

  return _react2['default'].cloneElement(childToClone, _extends({
    theme: (0, _pick2['default'])(theme, Object.keys(shape))
  }, props), childToClone.props.children);
};

exports['default'] = extendChild;